import * as tslib_1 from "tslib";
import { GroupWrapper } from './GroupWrapper';
import { MediaApi } from '../../services';
var GroupDTO = /** @class */ (function (_super) {
    tslib_1.__extends(GroupDTO, _super);
    function GroupDTO() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupDTO.prototype.setDetails = function (details) {
        var paths = Object.keys(details).map(function (key) { return "details." + key; });
        return this.updateGroup(paths, details);
    };
    GroupDTO.prototype.updateGroup = function (paths, details, settings) {
        if (details === void 0) { details = {}; }
        if (settings === void 0) { settings = {}; }
        var group = tslib_1.__assign({}, this.group, { details: tslib_1.__assign({}, this.group.details, details) }, { settings: tslib_1.__assign({}, this.group.settings, settings) });
        this.addUpdatePaths(paths);
        this.group = group;
        return this.group;
    };
    GroupDTO.prototype.addUpdatePaths = function (paths) {
        var _this = this;
        if (!this.updatePaths) {
            this.updatePaths = new Set();
        }
        paths.forEach(function (path) { return _this.updatePaths.add(path); });
    };
    GroupDTO.prototype.setSettings = function (settings) {
        var paths = Object.keys(settings).map(function (key) { return "settings." + key; });
        return this.updateGroup(paths, {}, settings);
    };
    /**
     * Sets a group title, returns new type `ApiTypes.v1.GroupResponse` object
     */
    GroupDTO.prototype.setTitle = function (title) {
        this.group = this.setDetails({ title: title });
        return this.group;
    };
    GroupDTO.prototype.setDescription = function (description) {
        this.group = this.setDetails({ description: description });
        return this.group;
    };
    GroupDTO.prototype.setMembersName = function (membersName) {
        this.group = this.setDetails({ membersName: membersName });
        return this.group;
    };
    GroupDTO.prototype.setMemberPermission = function (permittedToInviteMembers) {
        this.group = this.setSettings({ permittedToInviteMembers: permittedToInviteMembers });
        return this.group;
    };
    /**
     * Sets a group privacyLevel, returns new type `ApiTypes.v1.GroupResponse` object
     */
    GroupDTO.prototype.setPrivacy = function (privacyLevel) {
        this.group = this.setSettings({ privacyLevel: privacyLevel });
        return this.group;
    };
    GroupDTO.prototype.setLogoUrl = function (imageResponse) {
        this.setDetails(this.getCover(imageResponse));
        return this.group;
    };
    GroupDTO.prototype.isAddMembersBannerClosed = function () {
        try {
            var clientData = this.group.clientData;
            return clientData.isAddMembersBannerClosed === 'true';
        }
        catch (e) {
            return false;
        }
    };
    GroupDTO.prototype.getCover = function (uploadRes) {
        var _details = { logoUrl: null };
        if (!uploadRes) {
            return _details;
        }
        try {
            _details.logoUrl = this.getLogoUrlFromImageResponse(uploadRes);
            var file_name = uploadRes.file_name, width = uploadRes.width, height = uploadRes.height;
            _details.logo = {
                mediaId: file_name,
                width: width,
                height: height,
            };
        }
        catch (e) {
            console.log('Error in GroupDTO getCover');
        }
        return _details;
    };
    GroupDTO.prototype.getLogoUrlFromImageResponse = function (image) {
        if (!image) {
            return null;
        }
        //TODO: logo url has max defined target width/height?
        return MediaApi.getImageUrl(image);
    };
    return GroupDTO;
}(GroupWrapper));
export { GroupDTO };
//# sourceMappingURL=GroupDTO.js.map